export const editorChannelWidth = 222;
export const editorMarginTop = 18;
export const editorMarginBottom = 40;
export const scrollerSize = 14;
export const zoomSlideSize = 120;